export default "__VITE_ASSET__BRYMVJBb__"